export enum ImageUploaderModalType {
  IMAGE_UPLOAD_CANCEL = 'IMAGE_UPLOAD_CANCEL', // 이미지 업로드 페이지 상단 '취소'버튼 클릭하여 페이지 떠날 시
  IMAGE_DELETE_CONFIRM = 'IMAGE_DELETE_CONFIRM', // 이미지 삭제 버튼 클릭시 확인

  IMAGE_EDIT_CANCEL = 'IMAGE_EDIT_CANCEL', // 이미지 정보 수정 페이지 상단 '취소'버튼 클릭하여 페이지 떠날 시

  IMAGE_UPLOAD_REQUEST_FAIL = 'IMAGE_UPLOAD_REQUEST_FAIL', // 이미지 생성/편집 관련 요청 실패
  IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS', // 이미지 생성/편집 성공
  IMAGE_FILE_TYPE_ERROR = 'IMAGE_FILE_TYPE_ERROR', // 이미지 파일 타입 에러
  IMAGE_FILE_SIZE_ERROR = 'IMAGE_FILE_SIZE_ERROR', // 이미지 파일 용량 에러
  OMIT_REQUIRED_INPUT = 'OMIT_REQUIRED_INPUT' // 필수 입력란 누락
}
